<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-full max-w-xl"
  data-testid="attribute-consistency-dialog"
>
  <ng-template #header>
    <div class="flex items-center gap-3">
      @if (scaNumber(); as number) {
        <span
          class="bg-third-level rounded-md px-2 py-1 text-xs whitespace-nowrap"
          data-testid="attribute-consistency-dialog-sca"
        >
          SCA {{ number }}
        </span>
      }
      <h2 class="text-lg font-semibold m-0">
        {{ 'evaluation.consistency.dialog.title' | transloco }}
      </h2>
    </div>
  </ng-template>

  <div class="flex flex-col gap-4">
    <p class="m-0" data-testid="attribute-consistency-dialog-attribute">
      {{ attributeTranslations() | translateDirectus }}
    </p>

    <div class="bg-third-level rounded-lg px-3 py-2 text-sm">
      <span class="text-gray-400"> {{ 'evaluation.consistency.dialog.status' | transloco }}: </span>
      <span
        class="font-semibold ml-1"
        [style.color]="statusColor()"
        data-testid="attribute-consistency-dialog-status"
      >
        {{ statusLabelKey() | transloco }}
      </span>
    </div>

    <div class="flex flex-wrap gap-3">
      @if (representativeScoreLabelKey(); as scoreLabelKey) {
        <div class="bg-third-level rounded-lg px-3 py-2 text-sm flex-1">
          <span class="text-gray-400">
            {{ 'evaluation.consistency.dialog.representativeValue' | transloco }}:
          </span>
          <span class="font-semibold ml-1" data-testid="attribute-consistency-representative">
            {{ scoreLabelKey | transloco }}
          </span>
        </div>
      }
      <div class="bg-third-level rounded-lg px-3 py-2 text-sm flex-1 flex items-center gap-2">
        <span class="text-gray-400">
          {{ 'evaluation.consistency.dialog.homogeneityFactor' | transloco }}:
        </span>
        <span class="font-semibold" data-testid="attribute-consistency-homogeneity">
          {{ homogeneity() }}%
        </span>
        <i
          class="pi pi-info-circle text-gray-400"
          [pTooltip]="'evaluation.consistency.dialog.homogeneityInfo' | transloco"
          tooltipPosition="top"
        ></i>
      </div>
    </div>

    @if (hasRatings()) {
      <ul class="list-none p-0 m-0 flex flex-col gap-2" data-testid="attribute-consistency-ratings">
        @for (rating of ratings(); track rating.raterName) {
          <li class="flex items-center justify-between bg-third-level rounded-lg px-3 py-2">
            <span>{{ rating.raterName }}</span>
            @if (rating.scoreLabelKey; as scoreLabelKey) {
              <span class="font-medium">{{ scoreLabelKey | transloco }}</span>
            } @else {
              <span class="text-gray-400">&ndash;</span>
            }
          </li>
        }
      </ul>
    } @else {
      <p class="text-sm text-gray-400 m-0">
        {{ 'evaluation.consistency.dialog.noRatings' | transloco }}
      </p>
    }

    <div>
      <label
        class="block text-xs uppercase tracking-wide text-gray-400 mb-2"
        for="attribute-consistency-comment"
      >
        {{ 'evaluation.consistency.dialog.comment' | transloco }}
      </label>
      <textarea
        id="attribute-consistency-comment"
        pTextarea
        rows="3"
        class="w-full"
        [(ngModel)]="comment"
        [disabled]="saving()"
        [placeholder]="'evaluation.consistency.dialog.commentPlaceholder' | transloco"
        data-testid="attribute-consistency-comment"
      ></textarea>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'evaluation.consistency.dialog.accept' | transloco"
        severity="success"
        [disabled]="saving()"
        (onClick)="onAccept()"
        data-testid="attribute-consistency-accept"
      ></p-button>
      <p-button
        [label]="'evaluation.consistency.dialog.requestClarification' | transloco"
        severity="danger"
        [disabled]="saving()"
        (onClick)="onRequestClarification()"
        data-testid="attribute-consistency-clarify"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
